import React, { useContext } from 'react';
import { IUserJson } from '@scale/shared/types/user';
import { getWrapperComponentName } from '@scale/frontend-lib/util';

const UserContext = React.createContext<$FIXME | null>(null);

export default UserContext;

// @ts-ignore
export function withUser(Component) {
  // @ts-ignore
  const UserContextConsumerWrapper = props => (
    <UserContext.Consumer>{user => <Component {...props} user={user} />}</UserContext.Consumer>
  );

  UserContextConsumerWrapper.displayName = getWrapperComponentName('withUser', Component);

  return UserContextConsumerWrapper;
}

export function useUser(): IUserJson {
  return useContext(UserContext);
}
